<template>
  <VerifyPG state="success" />
</template>

<script>
import VerifyPG from "@/components/VerifyPG.vue";

export default {
  name: "App",
  components: {
    VerifyPG,
  },
};
</script>
